    function extractGraphQLError(err) {
        return (
        err?.errors?.[0] ||
        err?.response?.errors?.[0] ||
        null
        );
    }

    export function normalizeGraphQLError(err) {
        const gqlErr = extractGraphQLError(err);

        if (!gqlErr) {
            // Some libs throw plain Errors; don't render [object Object]
            const msg =
            typeof err?.message === "string" ? err.message :
            typeof err === "string" ? err :
            "Something went wrong.";
            return { global: msg };
        }

        let { message, errorType, errorInfo } = gqlErr;

        // ✅ If message is JSON, parse it (possibly multiple layers)
        if (typeof message === "string") {
            for (let i = 0; i < 3; i++) {
                const s = message.trim();
                if (!s.startsWith("{") || !s.endsWith("}")) break;

                try {
                const parsed = JSON.parse(message);

                // Only overwrite when present; keep previous values otherwise
                message   = parsed.message   ?? message;
                errorType = parsed.errorType ?? errorType;
                errorInfo = parsed.errorInfo ?? errorInfo;
                } catch {
                break; // stop if it isn't valid JSON at this layer
                }
            }
        }

        if (errorInfo && typeof errorInfo === "object") {
            return { global: message, ...errorInfo };
        }

        return { global: message || "Something went wrong." };
    }